"use client";

import Link from "@/lib/localized-link";
import { usePathname } from "next/navigation";
import { useT } from "@/lib/locale-context";
import { COMPARE_TABS } from "@/lib/nav-groups";
import { SEGMENT_ON } from "@/lib/ui-classes";

/** Shared selector for the two comparison tools - same segmented pill as
 *  CalcNav. Tabs come from the shared COMPARE_TABS so labels/routes match
 *  the desktop Compare dropdown + mobile sheet. */
export default function CompareNav() {
  const t = useT();
  const pathname = usePathname() ?? "";
  // Residences is the sub-route; everything else under /compare (including
  // /compare/h/[id] replays) belongs to the listings tab.
  const activeIdx = pathname.includes("/compare/residences") ? 1 : 0;
  return (
    <div className="mx-auto mb-8 max-w-md">
      <div className="relative flex rounded-full border border-gray-200 bg-white p-1">
        <span
          aria-hidden
          className={`absolute inset-y-1 left-1 rounded-full ${SEGMENT_ON} transition-transform duration-300 ease-out motion-reduce:transition-none`}
          style={{
            width: `calc((100% - 0.5rem) / ${COMPARE_TABS.length})`,
            transform: `translateX(${activeIdx * 100}%)`,
          }}
        />
        {COMPARE_TABS.map((tab, i) => (
          <Link
            key={tab.href}
            href={tab.href}
            aria-current={i === activeIdx ? "page" : undefined}
            className={`relative z-10 flex-1 rounded-full py-2 text-center text-sm font-semibold transition-colors ${
              i === activeIdx ? "text-indigo-700" : "text-gray-500 hover:text-gray-800"
            }`}
          >
            {t(tab.labelKey)}
          </Link>
        ))}
      </div>
    </div>
  );
}
